<template>
  <div class="badge" :class="`-${variant}`">{{ text }}</div>
</template>

<script>
const status = {
  PAID: {
    variant: 'success',
    text: 'Pago',
  },
  SUCCEEDED: {
    variant: 'success',
    text: 'Pago',
  },
  REVERTED: {
    variant: 'info',
    text: 'Devolvido',
  },
  REFUNDED: {
    variant: 'info',
    text: 'Devolvido',
  },
  CREATED: {
    variant: 'warning',
    text: 'Aguardando pagamento',
  },
  WAITING: {
    variant: 'warning',
    text: 'Aguardando pagamento',
  },
};

export default {
  name: 'PurchaseStatusBadge',

  props: {
    status: {
      required: true,
      type: String,
    },
  },

  computed: {
    variant() {
      return status[this.status.toUpperCase()] ? status[this.status.toUpperCase()].variant : this.status;
    },

    text() {
      return status[this.status.toUpperCase()] ? status[this.status.toUpperCase()].text : this.status;
    },
  },
};
</script>

<style scoped>

</style>
